import React, { useContext, useEffect, useState } from 'react';
import utilsMaster from '../../../../MyConns/_Utils/utilsMaster';
import { TheMasterContext } from '../../../MyContexts/Master_Context';
import SelectImgComp from '../../../MySections/ImagesSetter/SelectImgComp';

const TabSiteDetails = (props) => {
    const [theMaster, setTheMaster] = useContext(TheMasterContext);

    const [mainTitle, setMainTitle] = useState(theMaster.mainTitle);
    const [manageSiteLogo, setManageSiteLogo] = useState(theMaster.manageSiteLogo);
    const [printingOrderLogo, setPrintingOrderLogo] = useState(theMaster.printingOrderLogo);


    useEffect(() => {
        getMaster();
    }, [])



    const getMaster = async () => {
        let mst = await utilsMaster.getMaster();
        setTheMaster(mst)
        setManageSiteLogo(mst.manageSiteLogo)
        setPrintingOrderLogo(mst.printingOrderLogo)

    }



    const setTheLogo = (furl) => {
        theMaster.manageSiteLogo = furl;
        setManageSiteLogo(furl);
    
    }

    
    const setThePrintingLogo = (furl) => {
        theMaster.printingOrderLogo = furl;
        setPrintingOrderLogo(furl);
     
    }


    return (
        <>
            <div className={"col-md-12 mb-2"}>
                <label htmlFor={"validationCustom1_6"}>לוגו אזור ניהול</label>
                <span className={"explanation mediumst fullROw"}>מוצג על כפתור התפריט</span>
                <SelectImgComp firstImgToDisp={manageSiteLogo ? manageSiteLogo : ""} theFunction={(fUrl) => setTheLogo(fUrl)} />
            </div>
            <div className={"col-md-12 mb-2"}>
                <label htmlFor={"validationCustom1_6"}>לוגו עמוד הדפסה</label>
                <span className={"explanation mediumst fullROw"}>מוצג בעמוד הדפסת ההזמנה</span>
                <SelectImgComp firstImgToDisp={printingOrderLogo ? printingOrderLogo : ""} theFunction={(fUrl) => setThePrintingLogo(fUrl)} />
            </div>

        </>

    );
}

export default TabSiteDetails;